(() => {
  function init(root) {
    if (root.dataset.tierReady) return;
    const node = root.querySelector('[data-tier-data]');
    if (!node) return;
    root.dataset.tierReady = 'true';
    const config = JSON.parse(node.textContent);
    const section = root.closest('[data-set-product]');
    if (!section) return;
    const selects = [...section.querySelectorAll('[data-set-option-index]')];
    const format = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:config.currency || 'USD'}).format(amount / 100);
    const update = () => {
      const selected = selects.map(select => select.value);
      for (const tier of config.tiers) {
        const anchor = root.querySelector('[data-tier-choice="' + tier.tier + '"]');
        const variant = tier.variants.find(v => v.options.every((value,index) => value === selected[index]));
        const price = anchor.querySelector('[data-tier-price]');
        const valid = Boolean(variant && variant.available && tier.url);
        anchor.setAttribute('aria-disabled',String(!valid));
        if (valid) {
          const url = new URL(tier.url,location.origin);
          url.searchParams.set('variant',variant.id);
          anchor.href = url.pathname + url.search;
          anchor.removeAttribute('tabindex');
          price.textContent = format(variant.price);
        } else {
          anchor.removeAttribute('href');
          anchor.tabIndex = -1;
          price.textContent = config.unavailable;
        }
      }
    };
    root.addEventListener('click',event => {
      if (event.target.closest('[aria-disabled="true"]')) event.preventDefault();
    });
    selects.forEach(select => select.addEventListener('change',update));
    update();
  }
  const boot = () => document.querySelectorAll('[data-tx-base-tiers]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

(() => {
  const hydrate = async card => {
    if (card.dataset.priceReady) return;
    card.dataset.priceReady = 'true';
    try {
      const response = await fetch(card.dataset.homeTierUrl + '.js');
      if (!response.ok) throw new Error('Bundle unavailable');
      const product = await response.json();
      const variant = product.variants.reduce((lowest, item) => item.price < lowest.price ? item : lowest);
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:product.currency || 'USD'}).format(cents / 100);
      const price = card.querySelector('.tx-bundle-card__price');
      price.querySelector('strong').textContent = format(variant.price);
      let compare = price.querySelector('s');
      if (!compare) { compare = document.createElement('s'); price.append(compare); }
      const savings = variant.compare_at_price > variant.price;
      compare.hidden = !savings;
      compare.textContent = format(variant.compare_at_price || 0);
      let badge = card.querySelector('.tx-bundle-card__save');
      if (!badge) { badge = document.createElement('p'); badge.className = 'tx-bundle-card__save'; price.after(badge); }
      badge.hidden = !savings;
      badge.textContent = 'Save up to ' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + '%';
      card.querySelector('.tx-bundle-card__finance').textContent = 'Est. ' + format(variant.price / 48) + '/mo for 48 months, WAC';
      card.querySelector('[data-home-bundle-pricing]').hidden = false;
    } catch (error) { delete card.dataset.priceReady; }
  };
  const boot = () => document.querySelectorAll('[data-home-tier-url]').forEach(hydrate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
